const swagger = {
    invalid_zod_type: 'Zodのタイプが無効です。ルートガード構成を確認してください。',
    not_supported_zod_type_for_params: 'パラメータにサポートされていないZodタイプがあります。ルートガード構成を確認してください。',
};
export default swagger;
